import { DateRangeFilter } from '../components/DateRangeFilter';
import { MapCanvas } from '../components/MapCanvas';
import { SegmentTable } from '../components/SegmentTable';
import { VisitTable } from '../components/VisitTable';
import type { AnalysisResult, DateRange } from '../domain/models';

type MapPageProps = {
  result: AnalysisResult;
  fullResult: AnalysisResult;
  range: DateRange;
  onRangeChange: (range: DateRange) => void;
};

export function MapPage({ result, fullResult, range, onRangeChange }: MapPageProps) {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Map View</h1>
          <p className="page-subtitle">再生ボタンで時系列の動きを確認できます。カメラは基本固定にして、現在地マーカーと進行ルートだけを動かします。</p>
        </div>
        <DateRangeFilter range={range} min={fullResult.stats.dateStart} max={fullResult.stats.dateEnd} onChange={onRangeChange} />
      </header>

      <MapCanvas result={result} />

      <section className="grid two">
        <div className="section">
          <h2 className="section-title">滞在地点</h2>
          <VisitTable visits={result.visits.slice(0, 40)} />
        </div>
        <div className="section">
          <h2 className="section-title">移動区間</h2>
          <SegmentTable segments={result.segments.slice(0, 40)} />
        </div>
      </section>
    </div>
  );
}
